<!-- 签到 -->
<template>
    <div>
      <div class="course_SignIn">
        <el-row>
          <!-- <label>签到状态：</label>
          <el-select clearable v-model="status" filterable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
           -->
          <el-button type="success" icon="el-icon-map-location" @click="ipSign('ip_signin')">发起IP签到</el-button>
          <el-button type="success" icon="el-icon-s-promotion" @click="ipSign('code_signin')">发起验证码签到</el-button>
          <el-button type="success" icon="el-icon-s-check" @click="ipSign('manual_signin')">发起手动签到</el-button>
        </el-row>
        <el-row class="mt10 mb10">
          <label>签到汇总：</label>
          【
            合计签到次数：<span style="color: #409EFF;margin-right: 20px;">{{summaryInfo.totalSigninCount}} 次</span>
            合计签到人数：<span style="color: #409EFF;margin-right: 20px;">{{summaryInfo.totalSigninNumber}} 人</span>
            合计缺勤：<span style="color: #409EFF;margin-right: 20px;">{{summaryInfo.totalUnSigninNumber}} 人</span>
            合计到课率：<span style="color: #409EFF;">{{summaryInfo.TotalAttendanceRate}} %</span>
          】
        </el-row>
        <el-row class="content_block mt20">
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
              <el-table-column prop="time" header-align="center" align="center" label="签到日期">
                <template slot-scope="scope">
                  {{scope.row.teacherOpenCourseStudentSigninSettingSessionTime}}
<!--                  {{$timeFormat(scope.row.teacherOpenCourseStudentSigninSettingStartTime,'yyyy:MM:dd HH:mm')}}至-->
<!--                  {{$timeFormat(scope.row.teacherOpenCourseStudentSigninSettingEndTime,'yyyy:MM:dd HH:mm')}}-->
                </template>
              </el-table-column>
              <el-table-column prop="schoolClassIdsText" header-align="center" align="center" label="签到班级"> </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninSettingTypeText" header-align="center" align="center" label="签到方式">
                <template slot-scope="scope">
                  {{scope.row.teacherOpenCourseStudentSigninSettingTypeText}}
                  <template v-if="scope.row.teacherOpenCourseStudentSigninSettingValue">
                    </br>
                    <span style="color: #409EFF;">{{scope.row.teacherOpenCourseStudentSigninSettingValue}}</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="signinTotalCount" header-align="center" align="center" label="签到人数" width="100"> </el-table-column>
              <el-table-column prop="unsigninCount" header-align="center" align="center" label="缺勤人数" width="100"> </el-table-column>
              <el-table-column prop="signinStudentTotalCount" header-align="center" align="center" label="总人数" width="100"> </el-table-column>
              <el-table-column prop="signinTotalRate" header-align="center" align="center" label="到课率" width="100">
                <template slot-scope="scope">
                  {{scope.row.signinTotalRate || 0}} %
                </template>
              </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninSettingStatusText" header-align="center" align="center" label="状态" width="120">
                <template v-slot="scope">
                  <span :class="scope.row.teacherOpenCourseStudentSigninSettingStartStatus == 'ING'?'primary':scope.row.teacherOpenCourseStudentSigninSettingStartStatus == 'READY'?'mainWeak':'red'">
                    {{scope.row.teacherOpenCourseStudentSigninSettingStartStatus == 'ING'?"进行中":scope.row.teacherOpenCourseStudentSigninSettingStartStatus == 'READY'?"未开始":"已结束"}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="user_" header-align="center" align="center" label="操作" width="200">
                <template slot-scope="scope">
                  <template v-if="scope.row.teacherOpenCourseStudentSigninSettingType != 'manual_signin'">
                    <template v-if="scope.row.teacherOpenCourseStudentSigninSettingStartStatus === 'ING'">
                      <el-link type="danger" class="mr10" :underline="false" @click="startSignIn(scope.row,2)">结束签到</el-link>
                    </template>
                    <template v-if="scope.row.teacherOpenCourseStudentSigninSettingStartStatus === 'READY'">
                      <el-link type="primary" class="mr10" :underline="false" @click="startSignIn(scope.row,1)">开始签到</el-link>
                    </template>
                  </template>
                  <el-link type="primary" :underline="false" @click="signInDetails(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-row>

        <!-- 发起IP签到对话框 ip_signin:IP签到 code_signin：验证码签到 manual_signin：手动签到 -->
        <el-dialog
          :visible.sync="ipSignShow"
          width="700px"
        >
          <span slot="title">
            <i class="el-icon-map-location" style="margin-right: 10px;color: #67C23A;"></i>
            {{ipSignInfo.siginType == 'ip_signin'?'发起IP签到':ipSignInfo.siginType == 'code_signin'?'发起验证码签到':ipSignInfo.siginType == 'manual_signin'?'发起手动签到':'发起签到'}}
          </span>
          <el-form ref="form" :model="ipSignInfo" label-width="100px">
            <el-form-item label="签到班级">
              <el-select clearable style="width: 100%;" multiple v-model="ipSignInfo.schoolClassIds" placeholder="请选择签到班级">
                <template v-for="(item ,index) in classList">
                  <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <!-- <template v-if="ipSignInfo.siginType != 'manual_signin'"> -->
              <!-- <el-form-item label="签到时间">
                <el-date-picker
                  v-model="ipSignInfo.data"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  style="width: 100%;"
                  placeholder="选择日期">
                </el-date-picker> -->
<!--                <el-time-picker-->
<!--                  is-range-->
<!--                  v-model="ipSignInfo.time"-->
<!--                  range-separator="至"-->
<!--                  style="width: 295px;"-->
<!--                  value-format="HH:mm:ss"-->
<!--                  start-placeholder="开始时间"-->
<!--                  end-placeholder="结束时间"-->
<!--                  placeholder="选择时间范围">-->
<!--                </el-time-picker>-->
              </el-form-item>
            <!-- </template> -->
            <!-- IP签到时显示 -->
            <template v-if="ipSignInfo.siginType == 'ip_signin'">
              <el-form-item
                v-for="(domain, index) in ipSignInfo.ips"
                :label="'IP段' + (index + 1)"
                :key="domain.key"
                :prop="'ips.' + index + '.value'"
              >
                <el-input v-model="domain.value" style="width: 150px;"></el-input>
                <el-input v-model="domain.value1" style="width: 150px;"></el-input>
                <el-button type="primary" icon="el-icon-circle-plus-outline" v-if="index == 0" @click="addDomain"></el-button>
                <el-button type="danger" icon="el-icon-remove-outline" v-if="index > 0" @click.prevent="removeDomain(domain)"></el-button>
              </el-form-item>
            </template>

            <!-- 验证码签到时显示 -->
            <template v-if="ipSignInfo.siginType == 'code_signin'">
              <el-form-item label="创建验证码">
                <el-input style="width: 350px;" disabled v-model="ipSignInfo.code" placeholder="点击随机创建3位数字 + 3位小写字母 的验证码"></el-input>
                <i title="生成验证码" @click="generateCode" class="el-icon-refresh font20 ml10 mt5 c_p"></i>
                <i title="复制" @click="copyInfo" class="el-icon-document-copy font20 ml10 mt5 c_p"></i>
              </el-form-item>
            </template>

            <!-- 手动签到时显示 -->
            <template v-if="ipSignInfo.siginType == 'manual_signin'">
              <el-form-item label="随机抽取">
                <el-input style="width: 200px;" v-model="ipSignInfo.randomCount" placeholder="请输入抽取人数"></el-input>
                <el-button type="primary" icon="el-icon-refresh" @click="randomGet">随机抽取</el-button>
                <el-button icon="el-icon-refresh-right" @click="againGet">重新抽取</el-button>
                <p style="color: #858585;margin: 0;">未抽取到的学生自动默认为已签到</p>
              </el-form-item>
              <el-table
                :data="randomStudentList"
                border
                max-height="300px"
                style="width: 100%">
                <el-table-column type="index" header-align="center" align="center" label="序号" width="60"></el-table-column>
                <el-table-column prop="studentName" label="姓名" header-align="center" align="center" width="100"></el-table-column>
                <el-table-column prop="studentSn" label="学号" header-align="center" align="center" width="120"></el-table-column>
                <el-table-column prop="classIdText" label="班级" header-align="center" align="center"></el-table-column>
                <el-table-column prop="signType" label="状态" header-align="center" align="center">
                  <template slot-scope="scope">
                    <!-- SIGN_IN（签到）或者UN_SIGN_IN（缺勤） -->
                    <el-link type="primary" v-if="scope.row.signType =='SIGN_IN'" :underline="false">已签到</el-link>
                    <el-link type="danger" v-if="scope.row.signType =='UN_SIGN_IN'" :underline="false">缺勤</el-link>
                    <span style="color: #a7a7a7;" v-if="scope.row.signType == null || scope.row.signType ==''">未签到</span>
                  </template>
                </el-table-column>
                <el-table-column prop="cz" label="操作" header-align="center" align="center" width="100">
                  <template slot-scope="scope">
                    <el-link type="primary" class="mr10" :underline="false" @click="stuSignIn(scope.$index)">签到</el-link>
                    <el-link type="danger" :underline="false" @click="absenceSignIn(scope.$index)">缺勤</el-link>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;display: none;">
                <el-pagination
                  @size-change="handleSizeChange_stu"
                  @current-change="handleCurrentChange_stu"
                  :current-page.sync="currentPage1_stu"
                  :page-sizes="[5, 10, 30, 100]"
                  :page-size="limit_stu"
                  background
                  :hide-on-single-page="true"
                  layout="sizes, prev, pager, next,jumper"
                  :total="total_stu">
                </el-pagination>
              </div>
            </template>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="ipSignShow = false">取 消</el-button>
            <el-button type="primary" @click="submitIpSiginIn">确 认</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="缺勤理由"
          :visible.sync="absenceSignInShow"
          width="30%">
            <label>缺勤理由：</label>
            <el-select v-model="teacherOpenCourseStudentSigninLogRemark" placeholder="请选择">
              <el-option value="事假" label="事假"></el-option>
              <el-option value="病假" label="病假"></el-option>
              <el-option value="旷课" label="旷课"></el-option>
              <el-option value="其他" label="其他"></el-option>
            </el-select>
          <span slot="footer" class="dialog-footer">
            <el-button @click="absenceSignInShow = false">取 消</el-button>
            <el-button type="primary" @click="subAbsenceSignIn">确 定</el-button>
          </span>
        </el-dialog>

      </div>
    </div>
</template>
<script>
import {getClassInfo} from "@/common/getInfo";	//加载数据
export default {
  name: 'SignIn',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      options: [{
        value: '选项1',
        label: '未签到'
      }, {
        value: '选项2',
        label: '已签到'
      }, {
        value: '选项3',
        label: '缺勤'
      }],
      status: '',
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      ipSignShow:false,
      siginInNo:"",
      ipSignInfo:{
        schoolClassIds:[], //班级
        ips: [{
          value: '',
          value1: '',
        }],
        code:"",
        siginType:"", //签到类型
        randomCount:""
      },
      manualSignInfo:{
        bj:""
      },
      classList:[], //班级信息
      randomStudentList:[],
      currentPage1_stu: 1,
      total_stu: 0,
      limit_stu:5,
      page_stu:1,
      summaryInfo:{}, //数据统计值
      oNindex:false, //当前操作的位置
      absenceSignInShow:false,
      teacherOpenCourseStudentSigninLogRemark:null //缺勤理由
    }
  },
  created() {
    this.getInfo();
    this.getSummary();
    getClassInfo({teacherOpenCourseId:this.courseId}).then(ret =>{ //根据课程ID获取班级信息
      if(ret.code == 0){
        this.classList = ret.data;
      }
    })
  },
  mounted() {
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    handleSizeChange_stu(val) {
      console.log(`每页 ${val} 条`);
      this.limit_stu = val;
      this.randomGet();
    },
    handleCurrentChange_stu(val) {
      console.log(`当前页: ${val}`);
      this.page_stu = val;
      this.randomGet();
    },
    getInfo(){ //获取签到数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseStudentSigninSettingStatus:this.status,
        teacherOpenCourseId:this.courseId
      }
      this.$post("/api/teacherOpenCourseStudentSigninSetting/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getSummary(){ //获取统计信息
      this.$post("/api/teacherOpenCourseStudentSigninLog/summary.do",{teacherOpenCourseId:this.courseId}).then((ret) =>{
        if(ret.code == 0){
          this.summaryInfo = ret.data;
        }
      });
    },
    startSignIn(item,status){ //开始签到
      this.$confirm('是否确定'+(status == 1?'开始':'结束')+'签到?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          id:item.teacherOpenCourseStudentSigninSettingId,
          status:status,
          signinSettingType: item.teacherOpenCourseStudentSigninSettingType
        }
        this.$post("/api/teacherOpenCourseStudentSigninSetting/updateStatus.do",param).then((ret) =>{
          if(ret.code == 0){
            this.$message({type: 'success',message: '操作成功！'});
            this.getInfo();
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    signInDetails(item){ //签到详情
      this.$router.push({name:'SignInDetails',query:{courseId:this.courseId,signinSettingId:item.teacherOpenCourseStudentSigninSettingId}});
    },
    ipSign(siginType){ //打开签到对话框
      this.ipSignInfo = {
        schoolClassIds:[], //班级
        ips: [{
          value: '',
          value1: '',
        }],
        code:"",
        siginType:siginType, //签到类型
        randomCount:""
      };
      this.randomStudentList = [];
      this.ipSignShow = true;
    },
    submitIpSiginIn(){ //提交签到信息
      // ip_signin:IP签到 code_signin：验证码签到 manual_signin：手动签到
      if(this.ipSignInfo.schoolClassIds.length <= 0){
        this.$message({message: '请选择签到班级！',type: 'warning'});
        return;
      }
      let url = "/api/teacherOpenCourseStudentSigninSetting/add.do",param = {};
      if(this.ipSignInfo.siginType != "manual_signin"){
        // if(this.$isEmpty(this.ipSignInfo.data)){
        //   this.$message({message: '请选择签到日期！',type: 'warning'});
        //   return;
        // }
        // if(this.$isEmpty(this.ipSignInfo.time)){
        //   this.$message({message: '请选择签到时间！',type: 'warning'});
        //   return;
        // }
        param = {
          teacherOpenCourseId:this.courseId, //开课ID
          teacherOpenCourseStudentSigninSettingType:this.ipSignInfo.siginType, //签到类型
          schoolClassIds:this.ipSignInfo.schoolClassIds.join(","), //班级
          // teacherOpenCourseStudentSigninSettingStartTime:this.ipSignInfo.time[0],
          // teacherOpenCourseStudentSigninSettingEndTime:this.ipSignInfo.time[1]
        }
        if(this.ipSignInfo.siginType == "ip_signin"){ //IP签到
          let ip = "";
          for(let i in this.ipSignInfo.ips){
            if(this.$isEmpty(this.ipSignInfo.ips[i].value) || this.$isEmpty(this.ipSignInfo.ips[i].value1)){
              this.$message({message: '请输入完善ip段信息！',type: 'warning'});
              return;
            }else{
              ip += this.ipSignInfo.ips[i].value + "-" + this.ipSignInfo.ips[i].value1;
              if(i < this.ipSignInfo.ips.length - 1){
                ip += ",";
              }
            }
          }
          param.teacherOpenCourseStudentSigninSettingValue = ip;
        }else if(this.ipSignInfo.siginType == "code_signin"){ //验证码签到
          if(this.$isEmpty(this.ipSignInfo.code)){
            this.$message({message: '请生成验证码！',type: 'warning'});
            return;
          }
          param.teacherOpenCourseStudentSigninSettingValue = this.ipSignInfo.code;
        }
      }else if(this.ipSignInfo.siginType == "manual_signin"){ //手动签到
        url = "/api/teacherOpenCourseStudentSigninLog/manualSigninAdd.do";
        let list = new Array();
        if(this.randomStudentList.length <= 0){
          this.$message({message: '请生成需要签到的学生！',type: 'warning'});
          return;
        }
        for(let i in this.randomStudentList){
          if(this.$isEmpty(this.randomStudentList[i].signType)){
            this.$message({message: '请完成签到再提交！',type: 'warning'});
            return;
          }
          list.push({
            studentId:this.randomStudentList[i].studentId,
            teacherOpenCourseStudentSigninLogRemark: this.randomStudentList[i].remark, //缺勤时必填
            teacherOpenCourseStudentSigninLogTag: this.randomStudentList[i].signType //SIGN_IN（签到）或者UN_SIGN_IN（缺勤）
          })
        }
        param.signinSetting = {
          teacherOpenCourseId: this.courseId,
          schoolClassIds: this.ipSignInfo.schoolClassIds.join(",")
        }
        param.signinLogList = list
      }

      // if(this.$isEmpty(this.ipSignInfo.data)){
      //   this.$message({message: '请选择签到时间！',type: 'warning'});
      //   return;
      // }
      // param.teacherOpenCourseStudentSigninSettingSessionTime = this.ipSignInfo.data + ":00";

      this.submitInfo(url,param);
    },
    removeDomain(item) { //删除IP签到端
      var index = this.ipSignInfo.ips.indexOf(item)
      if (index !== -1) {
        this.ipSignInfo.ips.splice(index, 1)
      }
    },
    addDomain() { //新增IP签到端
      this.ipSignInfo.ips.push({
        value: '',
        key: Date.now()
      });
    },
    generateCode(){ //生成验证码
      let str = (Math.random()+"").slice(-3);
      this.ipSignInfo.code = str +""+ this.$GetRandomLetters(3).toLowerCase();
    },
    copyInfo() { //复制
      if(this.$isEmpty(this.ipSignInfo.code)){
        this.$message({message: '请先生成验证码！',type: 'warning'});
        return;
      }
      var input = document.createElement("input"); // 创建input对象
      input.value = this.ipSignInfo.code; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message({message:"复制成功",type:'success'});
    },
    randomGet(){ //随机获取
      let param = {
        randomCount:this.ipSignInfo.randomCount,
        teacherOpenCourseId:this.courseId,
        schoolClassIds:this.ipSignInfo.schoolClassIds.join(",")
        // limit:this.limit_stu,
        // page:this.page_stu,
      }
      this.$post("/api/teacherOpenCourseMergeStudent/randomStudentList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total_stu = Number(ret.count);
          this.randomStudentList = [];
          for(let i in ret.data){
            ret.data[i].signType = "";
            ret.data[i].remark = "";
            this.randomStudentList.push(ret.data[i]);
          }
        }
      })
    },
    againGet(){ //重新抽取
      this.randomGet();
    },
    stuSignIn(index){ //签到
      //SIGN_IN（签到）或者UN_SIGN_IN（缺勤）
      this.randomStudentList[index].signType = "SIGN_IN";
      this.$message({message:"签到成功",type:'success'});
    },
    absenceSignIn(index){ //缺勤
      this.absenceSignInShow = true;
      this.teacherOpenCourseStudentSigninLogRemark = null;
      this.oNindex = index;

      // this.$prompt('请输入缺勤备注', '信息', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputPattern:/\S/,
      //   inputErrorMessage: '缺勤备注不能为空'
      // }).then(({ value }) => {
      //   this.randomStudentList[index].remark = value;
      //   this.randomStudentList[index].signType = "UN_SIGN_IN";
      //   this.$message({message:"操作成功",type:'success'});
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '取消输入'
      //   });
      // });
    },
    subAbsenceSignIn(){
      if(this.$isEmpty(this.teacherOpenCourseStudentSigninLogRemark)){
        this.$message.warning("请选择缺勤理由！");
        return;
      }
      this.absenceSignInShow = false;
      this.randomStudentList[this.oNindex].remark = this.teacherOpenCourseStudentSigninLogRemark;
      this.randomStudentList[this.oNindex].signType = "UN_SIGN_IN";
      this.$message({message:"操作成功",type:'success'});
    },
    submitInfo(url,param){ //提交发起签到数据
      this.$postJSON(url,param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.ipSignShow = false;
          this.$message({message:"操作成功！",type:'success'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_SignIn{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-left: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/SignIn.vue